import { Box, Button, ButtonAppearance, Modal, ModalBody, ModalSize, Text } from '@bechtel/gds';
import { FC } from 'react';
import { ModalCloseStyled, ModalContainerStyled, ModalFooterSecondaryStyled, ModalHeaderStyled } from './styled';
import { ErrorProps } from './types';

export const ErrorModal: FC<ErrorProps> = ({
  close,
  message,
  title,
  closeText,
  errorDetails,
  minHeight = '275px',
  maxHeight = '275px',
}) => {
  const showErrorList = () => {
    return errorDetails?.map((item) => {
      return (
        <Box flexDirection={{ sm: 'column' }}>
          <Box style={{ marginBottom: 12, flexDirection: 'column' }}>
            <Text size="400" color="red.700">
              {item.title}
            </Text>
            <Text size="300" style={{ marginTop: 4, marginBottom: 4 }}>
              {item.description}
            </Text>
          </Box>
        </Box>
      );
    });
  };
  return (
    <Modal
      visible
      size={ModalSize.LARGE}
      style={{ ...ModalContainerStyled, minHeight: minHeight, maxHeight: maxHeight }}
    >
      <ModalHeaderStyled title={title}>
        <ModalCloseStyled onClick={close}></ModalCloseStyled>
      </ModalHeaderStyled>
      <ModalBody>
        {!errorDetails ? (
          <Box p={{ sm: '500' }} flexDirection={{ sm: 'column' }}>
            <Box p={{ sm: '500' }}>
              <Text>{message}</Text>
            </Box>
          </Box>
        ) : (
          <Box p={{ sm: '500' }} flexDirection={{ sm: 'column' }}>
            {showErrorList()}
          </Box>
        )}
      </ModalBody>
      <ModalFooterSecondaryStyled>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.PRIMARY} onClick={close}>
              {closeText}
            </Button>
          </Box>
        </Box>
      </ModalFooterSecondaryStyled>
    </Modal>
  );
};
